import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { Reveal } from './Reveal';
export function GuaranteeSection() {
  return <section className="bg-brand-dark px-4 py-20" data-id="element-90" data-mp="4vs1604r2hrx">
      <Reveal className="mx-auto max-w-2xl text-center" data-id="element-91" data-mp="9umi0wj5pw9e">
        <div className="mb-6 inline-flex h-16 w-16 items-center justify-center rounded-full bg-brand-alt shadow-sm" data-id="element-92" data-mp="9t1lx2h7259f">
          <ShieldCheckIcon className="h-8 w-8 text-brand-green" aria-hidden="true" data-id="element-93" data-mp="er35doij86lf" />
        </div>
        <h2 className="text-2xl font-extrabold tracking-tight text-brand-blue md:text-3xl" data-id="element-94" data-mp="jqpuowbmxdal">
          🛡️ Rimborso Garantito o Lo Tieni Comunque.
        </h2>
        <p className="mt-6 leading-relaxed text-brand-gray" data-id="element-95" data-mp="sm5jgyxj929b">
          Se ARTE PRONTA™ non fa al caso tuo, scrivici entro 30 giorni per il rimborso completo. Nessuna domanda. E se
          decidi di tenerlo, resta tuo per sempre.
        </p>
      </Reveal>
    </section>;
}